import { SurveyService } from './SurveyService'
import SurveyServiceInterface from './SurveyServiceInterface'

export default new SurveyService() as SurveyServiceInterface
